import React from 'react';
import TicTacToe from './components/TicTacToe/TicTacToe';

import './App.scss';

function App() {
  return (
    <div className='container'>
      <TicTacToe></TicTacToe>
    </div>
  );
}

export default App;
